import commonTranslations from 'common-translations/src/vtj/i18next'

export default function translateLoginError(errorMessage, lang) {
  const translate = commonTranslations.getFixedT(lang)
  if (errorMessage === 'authenticationFailure') {
    return (
      <div>
        <p>{translate('authenticationFailure_1')}</p>
        <p>{translate('authenticationFailure_2')}</p>
        <p>{translate('authenticationFailure_3')}</p>
      </div>
    )
  }
  return translate(errorMessage)
}
